/**
 * Utility functions for converting between integer and decimal monetary values.
 * In the Grid system, monetary values are stored as integers that are fractions
 * of the actual monetary value (multiplied by DECIMAL_SCALE_MULTIPLIER).
 */// The multiplier used to convert between decimal and integer values
export const DECIMAL_SCALE_MULTIPLIER=100000;/**
 * Converts an integer value to a decimal value for display/form input
 * @param integerValue The integer value from the API
 * @returns The decimal value for display
 */export const toDecimalValue=integerValue=>integerValue/DECIMAL_SCALE_MULTIPLIER;/**
 * Converts a decimal value to an integer value for API
 * @param decimalValue The decimal value from the UI
 * @returns The integer value for the API
 */export const toIntegerValue=decimalValue=>Math.round(decimalValue*DECIMAL_SCALE_MULTIPLIER);/**
 * Safely converts an integer value to a decimal value, handling null/undefined
 * @param integerValue The integer value from the API
 * @returns The decimal value for display or undefined if input is null/undefined
 */export const safeToDecimalValue=integerValue=>integerValue!=null?toDecimalValue(integerValue):undefined;/**
 * Safely converts a decimal value to an integer value, handling null/undefined
 * @param decimalValue The decimal value from the UI
 * @returns The integer value for the API or undefined if input is null/undefined
 */export const safeToIntegerValue=decimalValue=>decimalValue!=null?toIntegerValue(decimalValue):undefined;